import React from 'react';
import { render } from '@testing-library/react';
import { Dialog } from './Dialog';

describe('Dialog', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	/**
	 * NOTE: Using "baseElement" instead of "container" because
	 *       Dialog's children are rendered in a portal
	 */
	it('should pass through data automation attributes', () => {
		const { container, baseElement } = render(
			<Dialog
				open
				title="Save for later?"
				onPrimaryActionClick={jest.fn()}
				primaryActionName="Save"
				onSecondaryActionClick={jest.fn()}
				secondaryActionName="Cancel"
				data-auto-sel="automation-selector"
			>
				You can always set up this campaign at a later time.
			</Dialog>
		);

		const nonPortalElement = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);
		const portalElement = baseElement.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(nonPortalElement).toBeNull();
		expect(portalElement).not.toBeNull();
	});
});
